import { useTranslation } from "react-i18next";
import {
  CurrentPositionMarkerProps,
  EndPointMarkerProps,
  StartPointMarkerProps,
  WaypointMarkerProps,
} from "./types";

// Current position - larger green circle with pulse
export const CurrentPositionMarker = ({
  point,
}: CurrentPositionMarkerProps) => {
  const { t } = useTranslation();

  return (
    <g>
      <circle
        cx={point.x}
        cy={point.y}
        r="5"
        fill="#00ff00"
        stroke="#ffffff"
        opacity="0.9"
      >
        <animate
          attributeName="r"
          values="5;7;5"
          dur="2s"
          repeatCount="indefinite"
        />
      </circle>
      <text
        x={point.x}
        y={point.y + 12}
        fontSize="7"
        textAnchor="middle"
        className="font-mono font-bold"
        fill="#00ff00"
        stroke="#000"
        strokeWidth="0.6"
        paintOrder="stroke fill"
      >
        {t("doc_viewer.you")}
      </text>
    </g>
  );
};

// Start position - green circle with border
export const StartPointMarker = ({
  point,
  frameName,
  onSelectedFrameIndexChange,
}: StartPointMarkerProps) => {
  const { t } = useTranslation();

  return (
    <g>
      <circle
        cx={point.x}
        cy={point.y}
        r="4"
        fill="#ffbb00"
        stroke="#ffffff"
        strokeWidth="1"
        opacity="0.9"
        className="cursor-pointer hover:opacity-100 transition-opacity"
        onClick={() =>
          onSelectedFrameIndexChange({
            newIndex: 0,
            frameName,
          })
        }
      />
      <title>
        {t("doc_viewer.start_frame", {
          frameName,
        })}
      </title>
      <text
        x={point.x}
        y={point.y + 12}
        fontSize="6"
        textAnchor="middle"
        className="font-mono font-bold"
        fill="#ffbb00"
        stroke="#000"
        strokeWidth="0.6"
        paintOrder="stroke fill"
      >
        {t("doc_viewer.start")}
      </text>
    </g>
  );
};

// End position - red circle with border
export const EndPointMarker = ({
  point,
  frameName,
  endFrameIndex,
  onSelectedFrameIndexChange,
}: EndPointMarkerProps) => {
  const { t } = useTranslation();

  return (
    <g>
      <circle
        cx={point.x}
        cy={point.y}
        r="4"
        fill="#ff0000"
        stroke="#ffffff"
        strokeWidth="1"
        opacity="0.9"
        className="cursor-pointer hover:opacity-100 transition-opacity"
        onClick={() =>
          onSelectedFrameIndexChange({
            newIndex: endFrameIndex,
            frameName,
          })
        }
      />
      <title>
        {t("doc_viewer.end_frame", {
          frameName,
        })}
      </title>
      <text
        x={point.x}
        y={point.y + 12}
        fontSize="6"
        textAnchor="middle"
        className="font-mono font-bold"
        fill="#ff0000"
        stroke="#000"
        strokeWidth="0.6"
        paintOrder="stroke fill"
      >
        {t("doc_viewer.end")}
      </text>
    </g>
  );
};

export const WaypointMarker = ({
  point,
  frameIndex,
  frameName,
  onSelectedFrameIndexChange,
}: WaypointMarkerProps) => {
  return (
    <circle
      cx={point.x}
      cy={point.y}
      r="3"
      fill="#0088ff"
      stroke="#ffffff"
      strokeWidth="0.9"
      className=" transition-all duration-200 ease-out hover:[r:5px] cursor-pointer group-[.edit-mode]:hover:[r:3px] group-[.edit-mode]:!cursor-[inherit]"
      onClick={() =>
        onSelectedFrameIndexChange({
          newIndex: frameIndex,
          frameName,
        })
      }
    />
  );
};
